<template>
  <v-card>
    <tiptap-vuetify
      v-model="editText"
      :extensions="extensions"
      :card-props="{ flat: true }"
    />
    <v-card-actions>
      <v-spacer>
      </v-spacer>
      <v-btn color="#ec1946" @click="$emit('cancel')">
        <span class="white--text">
          Отменить
        </span>
      </v-btn>
      <v-btn color="#1f51a4" @click="$emit('save', editText)">
        <span class="white--text">
          Сохранить
        </span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'
export default {
  name: 'SStructTextEdit',
  components: { TiptapVuetify },
  props: {
    SStructText: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3]
            }
          }
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
      ],
      editText: this.SStructText
    }
  }
}
</script>

<style scoped>

</style>
